export const LIMIT = 5000;

export const VIEW_ADMINISTRATIVE = "administrative";
export const VIEW_CONSTITUENCY = "constituency";
